<template>
  <div>
    <Layout>
      <imageList :imageList="imageList" :isDouble="true" />
    </Layout>
  </div>
</template>

<script>
import Layout from '@/views/public/layout'
import config from '@/config'
import imageList from '@/component/imageList'
export default {
  data() {
    return {
      imageList: []
    };
  },
  methods: {
  },
  components: {
    Layout,
    imageList
  },
  created() {
    let imgList = [];
    config.pageData.overViewMen.SPRING22.LOOKBOOK.map((item) => {
      imgList.push(item)
    })
    this.imageList = imgList;
  }
}

</script>
